export default {
  company: "companies",
  consignment: "consignments",
  part: "parts",
  incomingQuote: "incoming_quotes",
  outgoingQuote: "outgoing_quotes",
  lot: "lots",
  managedRepairOrder: "managed_repair_orders",
  purchaseOrder: "purchase_orders",
  receivingRecord: "receiving_records",
  repairOrder: "repair_orders",
  rma: "rmas",
  inventory: "inventories",
  mistakeShipment: "mistake_shipments",
  salesOrder: "sales_orders",
  shipment: "shipments"
};



// WEBPACK FOOTER //
// ./app/modules/shared/types/resourceTypes.js